import { useCookieStorage } from "@kivra/sdk/storage";
import type { ThemeName } from "./styled/theme";

/**
 * Cookie storage is used for the value to be available in defferent domains
 * e.g. accounts.kivra.com, inbox.kivra.com, settings.kivra.com...
 */
const preferredThemeStorage = useCookieStorage<ThemeName>({
  key: "PREFERRED_THEME",
});

/**
 * Get persisted theme name if stored.
 * Important: This function should only be used on a global level of the application
 * and not inside a component since the react tree can have nested themes. Eg. a
 * component can make its children be rendered in a different theme than what is
 * stored on a global level. KivraTheme uses this, so most likely you don't need to.
 */
export function getPersistedThemeName(): ThemeName | null {
  return preferredThemeStorage.get();
}

/**
 * Persists given theme name in cookie. If the theme name is absent, the stored cookie will
 * be removed.
 * Important: Setting the value will override users browser preference in KivraTheme.
 * This should only be used in a theme selection UI where the user can select a preferred value.
 */
export function setPersistedThemeName(theme?: ThemeName): void {
  if (!theme) {
    preferredThemeStorage.remove();
  } else {
    preferredThemeStorage.set(theme);
  }
}
